export default __webpack_public_path__ + "static/media/credit_icon_unlocked.ce72db70.svg";